module.exports = __webpack_public_path__ + "static/media/favicon.52895c0b.ico";